<div class="person-form-container">
  <form [formGroup]="personForm" (ngSubmit)="onSubmit()">


    <!-- Kind Field as selection boxes -->
    <div class="type-selection-container">
      <div class="type-selection-row">
        @if (!(person?.id > 0)) {
          <p class="red-text">Kliknij na kafelek celem wyboru rodzaju karty</p>
        }
        <input hidden matInput formControlName="type" />
        <div class="type-box" [class.selected]="personForm.get('type')?.value === 'CHILDREN'"
          (click)="!hasCards && personForm.get('type')?.setValue('CHILDREN')" [class.disabled]="hasCards"
          [style.pointer-events]="hasCards ? 'none' : 'auto'" [style.opacity]="hasCards ? '0.8' : '1'" tabindex="0">
          <div class="type-title">Rodzic <app-info-help [pageId]="'informacja_rodzaj_karty_rodzic'"
          [title]="'Karta rodzica'"></app-info-help></div>
          <div class="type-desc">Rodzic dziecka do 18 roku życia zamieszkałego  w Zielonej Górze </div>
        </div>
        <div class="type-box" [class.selected]="personForm.get('type')?.value === 'CITIZEN'"
          (click)="!hasCards && personForm.get('type')?.setValue('CITIZEN')" [class.disabled]="hasCards"
          [style.pointer-events]="hasCards ? 'none' : 'auto'" [style.opacity]="hasCards ? '0.8' : '1'" tabindex="0">
          <div class="type-title">Mieszkaniec <app-info-help [pageId]="'informacja_rodzaj_karty_mieszkaniec'"
          [title]="'Karta mieszkańca'"></app-info-help></div>
          <div class="type-desc">Osoba dorosła płacąca podatki w Zielonej Górze</div>
        </div>
        <div class="type-box" [class.selected]="personForm.get('type')?.value === 'STUDENT'"
          (click)="!hasCards && personForm.get('type')?.setValue('STUDENT')" [class.disabled]="hasCards"
          [style.pointer-events]="hasCards ? 'none' : 'auto'" [style.opacity]="hasCards ? '0.8' : '1'" tabindex="0">
          <div class="type-title">Uczeń/Student <app-info-help [pageId]="'informacja_rodzaj_karty_student'"
          [title]="'Karta studenta'"></app-info-help></div>
          <div class="type-desc">Osoba studiująca na Uniwersytecie Zielonogórskim lub innej szkole pomaturalnej do 26 roku życia</div>
        </div>
        <div class="type-box" [class.selected]="personForm.get('type')?.value === 'SENIOR'"
          (click)="!hasCards && personForm.get('type')?.setValue('SENIOR')" [class.disabled]="hasCards"
          [style.pointer-events]="hasCards ? 'none' : 'auto'" [style.opacity]="hasCards ? '0.8' : '1'" tabindex="0">
          <div class="type-title">Emeryt/Rencista <app-info-help [pageId]="'informacja_rodzaj_karty_senior'"
          [title]="'Karta seniora'"></app-info-help></div>
          <div class="type-desc">Rencista lub emeryt mieszkający w Zielonej Górze </div>
        </div>
      </div>
      <div class="fields-holder">

        <!-- Default Resident Checkbox -->
        <div class="default-resident-checkbox">
          <mat-checkbox formControlName="default" [value]="'1'">
            <strong>Mieszkaniec domyślny</strong> - Ta karta będzie pokazywana w aplikacji mobilnej
          </mat-checkbox>
        </div>


        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Imię</mat-label>
          <input appCamelCaseAutoFormat matInput formControlName="name" />
          @if (personForm.get('name')?.hasError('required')) {
            <mat-error>
              Imię jest wymagane
            </mat-error>
          }
          @if (personForm.get('name')?.hasError('minlength')) {
            <mat-error>
              Imię musi mieć co najmniej 3 znaki
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Drugie imię</mat-label>
          <input appCamelCaseAutoFormat matInput formControlName="name2" />
          @if (personForm.get('name2')?.hasError('required')) {
            <mat-error>
              Drugie imię jest wymagane
            </mat-error>
          }
          @if (personForm.get('name')?.hasError('minlength')) {
            <mat-error>
              Imię musi mieć co najmniej 3 znaki
            </mat-error>
          }
        </mat-form-field>

        <!-- SurName Field -->
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Nazwisko</mat-label>
          <input appCamelCaseAutoFormat matInput formControlName="surname" />
          @if (personForm.get('surname')?.hasError('required')) {
            <mat-error>
              Nazwisko jest wymagane
            </mat-error>
          }
          @if (personForm.get('surname')?.hasError('minlength')) {
            <mat-error>
              Nazwisko musi mieć co najmniej 3 znaki
            </mat-error>
          }
        </mat-form-field>

        <!-- Phone Field -->
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Numer telefonu</mat-label>
          <input matInput formControlName="phone" />
          @if (personForm.get('phone')?.hasError('pattern')) {
            <mat-error>
              Wpisz poprawny numer telefonu (np. 500001234)
            </mat-error>
          }
        </mat-form-field>

        <!-- Birthday Field -->
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Data urodzenia</mat-label>
          <input readonly (focus)="picker.open()" matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
            formControlName="birthday" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker startView="multi-year"></mat-datepicker>
          @if (personForm.get('birthday')?.hasError('required')) {
            <mat-error>
              Data urodzenia jest wymagana
            </mat-error>
          }
          @if (personForm.get('birthday')?.hasError('matDatepickerParse')) {
            <mat-error>
              Nieprawidłowy format daty
            </mat-error>
          }
          @if (personForm.get('birthday')?.hasError('matDatepickerMin')) {
            <mat-error>
              @if (personForm.get('type')?.value === 'STUDENT') {
                Student nie może mieć więcej niż 26 lat
              } @else {
                Data urodzenia nie może być starsza niż 120 lat
              }
            </mat-error>
          }
          @if (personForm.get('birthday')?.hasError('matDatepickerMax')) {
            <mat-error>
              Osoba musi mieć co najmniej 18 lat
            </mat-error>
          }
        </mat-form-field>

        <!-- Street Field -->
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Ulica</mat-label>
          <input matInput  formControlName="street" />
        </mat-form-field>

        <!-- Home Field -->
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Numer domu</mat-label>
          <input matInput formControlName="home" />
        </mat-form-field>

        <!-- City Field -->
        <div class="row-flex">
          <!-- Kod pocztowy -->
          <mat-form-field appearance="outline" class="form-field postcode-field">
            <mat-label>Kod pocztowy</mat-label>
            <input matInput formControlName="postcode" maxlength="6" />
            @if (personForm.get('postcode')?.hasError('pattern')) {
              <mat-error>
                Wpisz poprawny kod (np. 12-345)
              </mat-error>
            }
          </mat-form-field>

          <!-- Miejscowość -->
          <mat-form-field appearance="outline" class="form-field city-field">
            <mat-label>Miejscowość</mat-label>
            <input matInput formControlName="city" />
          </mat-form-field>
        </div>
      </div>

    </div>

    <div class="actions-holder">
      <div class="checkbox-container">
        <mat-checkbox formControlName="accept_news" class="accept-news-checkbox">
          Wyrażam zgodę na gromadzenie i przetwarzanie danych osobowych zawartych we wniosku o wydanie Karty ZGrane Grono
          dla celów związanych z otrzymywaniem informacji o promocjach oraz o specjalnych wydarzeniach partnerów programu.
        </mat-checkbox>
      </div>
      <p>
        <small>KKLAUZULA INFOMRACYJNA<br />
          Administratorem Pani/Pana danych osobowych jest Miejski Ośrodek Pomocy Społecznej w Zielonej Górze z siedzibą przy ul. Długiej 13, 65-401 Zielona Góra, z którym można skontaktować się mailowo
          biuro@mops.zgora.pl lub pisemnie na adres siedziby. W sprawach związanych z danymi osobowymi proszę kontaktować się z Inspektorem Ochrony Danych: iod@mops.zgora.pl. Pana/Pani dane osobowe będą
          przetwarzane w celu wydania karty oraz udziału w programie „ZGrane Grono”, na podstawie ustawy z dnia 12 marca 2004 r. o pomocy społecznej oraz w związku z realizacją zadania realizowanego w interesie
          publicznym (art. 6 ust. 1 lit. e RODO) oraz na podstawie wyrażonej zgody na otrzymywanie informacji o promocjach oraz o specjalnych wydarzeniach naszych partnerów (art. 6 ust. 1 lit. a RODO). W związku
          z przetwarzaniem Pani/Pana danych w celach wskazanych powyżej, dane osobowe będą udostępniane Partnerom Programu lub kategoriom odbiorców danych osobowych, którymi mogą być podmioty
          upoważnione do otrzymania Pani/Pana danych osobowych na podstawie odpowiednich przepisów prawa oraz podmioty, z którymi zawarto umowę związaną z obsługą programu, tj. Centrum Rekreacyjno-
          Sportowe w Zielonej Górze. W przypadku gdy podstawą prawną przetwarzania danych jest Pani/Pana zgoda dane będą przetwarzane do czasu jej usunięcia lub zakończenia celu przetwarzania. W pozostałych
          przypadkach Pani/Pana dane osobowe będą przetwarzane przez okres niezbędny do realizacji programu „ZGrane Grono”, a po tym czasie przez okres niezbędny do wypełnienia przez administratora obowiązków
          wynikających z ustawy z dnia 14 lipca 1983 r. o narodowym zasobie archiwalnym i archiwach oraz przepisów wykonawczych. Przysługuje Pani/Panu prawo żądania dostępu do danych, ich sprostowania,
          usunięcia lub ograniczenia przetwarzania oraz prawo do wniesienia sprzeciwu wobec przetwarzania danych. Ma Pani/Pan prawo do cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z prawem
          przetwarzania, którego dokonano na podstawia zgody przed jej cofnięciem. Przysługuje Pani/Panu również prawo wniesienia skargi do organu nadzorczego zajmującego się ochroną danych osobowych -
          Prezesa Urzędu Ochrony Danych Osobowych z siedzibą w Warszawie. Podanie danych jest dobrowolne, ale konieczne w celu wzięcia udziału w programie „ZGrane Grono”. Dane osobowe nie będą podlegały
          profilowaniu ani, na podstawie tych danych, nie będą podejmowane decyzje w sposób zautomatyzowany.
        </small>
      </p>

      <!-- Submit Button -->
   
    </div>
     <div class="center">
         <button class="custom-button" mat-raised-button color="primary" type="submit" [disabled]="personForm.invalid">
        Zapisz zmiany
      </button>
      </div>
  </form>
</div>
<p></p>